const sysCd = {
  // HVS: 'HVS',
  HIP: 'HIP',
  // HIPP: 'HIPP',
  // HYCOT: 'HYCOT'
}

const sysId = {
  // HVS: 'HVS',
  HIP: 'HIP',
  // HIPP: 'HIPP',
  // HYCOT: 'HYCOT'
}

export default {
  namespaced: true,

  state : {
      sysCd: '',
      sysId: ''
  },
  mutations: {
    SET_SYS_CD: (state, system) => {
      state.sysCd = sysCd[system] ? sysCd[system] : ''
    },
    SET_SYS_ID: (state, system) => {
      state.sysId = sysId[system] ? sysId[system] : ''
    }
  },
  actions: {
    ClearSession({
      commit
    }) {
      commit('SET_SYS_CD', '')
      commit('SET_SYS_ID', '')
    }
  }
}